import { render } from "./NewWork.vue?vue&type=template&id=bbc65b62&scoped=true"
import script from "./NewWork.vue?vue&type=script&lang=js"
export * from "./NewWork.vue?vue&type=script&lang=js"

import "./NewWork.vue?vue&type=style&index=0&id=bbc65b62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc65b62"]])

export default __exports__